import styled from "styled-components";
import { DEFAULT_PAPER_PADDING } from "../../constants/commonConstants";
import React from "react";
import { MarginLeftRow } from "../leftGrid";
import { withFilteredProps } from '@components/withFilteredProps/withFilteredProps';

const pageWidth = 762;
const bankStatementsWidth = 1080;

const getPadding = (props) => {
  const { padding } = props;
  return padding ?? DEFAULT_PAPER_PADDING;
};

export const _PaperWidthRow = (props) => (
  <MarginLeftRow {...props} style={{
    padding: `0 ${DEFAULT_PAPER_PADDING}px`, 
  }} />
);

export const PaperWidthRow = withFilteredProps(_PaperWidthRow);

const _Paper = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => {
    if (typeof defaultValidatorFn !== 'function') {
      // console.warn('defaultValidatorFn is not a function');
      return !['padding'].includes(prop);
    }
    return !['padding'].includes(prop) && defaultValidatorFn(prop);
  }
  })`
  width: 100%;
  box-sizing: border-box;
  max-width: ${pageWidth}px;
  padding: 0 ${getPadding}px;
  margin: 0 auto;
`;

export const Paper = withFilteredProps(_Paper);

export const BankStatementsPaper = styled.div`
  width: 100%;
  box-sizing: border-box;
  max-width: ${bankStatementsWidth}px;
  padding: 0;
  margin: 0 auto;
`;